"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChevronIcon = exports.Rotation = void 0;

var _react = _interopRequireDefault(require("react"));

var _ArrowDownIcon = require("./ArrowDownIcon");

var _ArrowLeftIcon = require("./ArrowLeftIcon");

var _ArrowRightIcon = require("./ArrowRightIcon");

var _ArrowUpIcon = require("./ArrowUpIcon");

var _rotationMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: This is for backwards compat with Volt; need to update there
var Rotation;
exports.Rotation = Rotation;

(function (Rotation) {
  Rotation[Rotation["LEFT"] = 0] = "LEFT";
  Rotation[Rotation["RIGHT"] = 1] = "RIGHT";
  Rotation[Rotation["UP"] = 2] = "UP";
  Rotation[Rotation["DOWN"] = 3] = "DOWN";
})(Rotation || (exports.Rotation = Rotation = {}));

var rotationMap = (_rotationMap = {}, _defineProperty(_rotationMap, Rotation.LEFT, _ArrowLeftIcon.ArrowLeftIcon), _defineProperty(_rotationMap, Rotation.RIGHT, _ArrowRightIcon.ArrowRightIcon), _defineProperty(_rotationMap, Rotation.UP, _ArrowUpIcon.ArrowUpIcon), _defineProperty(_rotationMap, Rotation.DOWN, _ArrowDownIcon.ArrowDownIcon), _rotationMap);
var directionMap = {
  left: _ArrowLeftIcon.ArrowLeftIcon,
  right: _ArrowRightIcon.ArrowRightIcon,
  up: _ArrowUpIcon.ArrowUpIcon,
  down: _ArrowDownIcon.ArrowDownIcon
};

/** ChevronIcon */
var ChevronIcon = function ChevronIcon(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "right" : _ref$direction,
      props = _objectWithoutProperties(_ref, ["direction"]);

  var Arrow = rotationMap[direction] || directionMap[direction];
  return /*#__PURE__*/_react.default.createElement(Arrow, props);
};

exports.ChevronIcon = ChevronIcon;
ChevronIcon.displayName = "ChevronIcon";
//# sourceMappingURL=ChevronIcon.js.map